import { render, staticRenderFns } from "./FileCardTr.vue?vue&type=template&id=14c27d06&"
import script from "./FileCardTr.vue?vue&type=script&lang=js&"
export * from "./FileCardTr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports